var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBfidTier4Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 22,
    viewBox: "0 0 53 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 22,
    rx: 11,
    fill: "url(#paint0_linear_13844_33817)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5093 8.2625H14.1113V15H12.6318V8.2625H10.2338V7.047H16.5093V8.2625ZM19.145 15H17.66V7.047H19.145V15ZM22.5206 8.224V10.4295H25.3036V11.568H22.5206V13.8175H26.0516V15H21.0356V7.047H26.0516V8.224H22.5206ZM29.8762 10.831C30.1549 10.831 30.3969 10.7962 30.6022 10.7265C30.8112 10.6568 30.9817 10.5615 31.1137 10.4405C31.2494 10.3158 31.3502 10.1692 31.4162 10.0005C31.4822 9.83183 31.5152 9.64667 31.5152 9.445C31.5152 9.04167 31.3814 8.73183 31.1137 8.5155C30.8497 8.29917 30.4446 8.191 29.8982 8.191H28.9522V10.831H29.8762ZM33.6822 15H32.3457C32.0927 15 31.9094 14.901 31.7957 14.703L30.1237 12.1565C30.0614 12.0612 29.9917 11.9933 29.9147 11.953C29.8414 11.9127 29.7314 11.8925 29.5847 11.8925H28.9522V15H27.4727V7.047H29.8982C30.4372 7.047 30.8992 7.10383 31.2842 7.2175C31.6729 7.3275 31.9901 7.48333 32.2357 7.685C32.4851 7.88667 32.6684 8.12867 32.7857 8.411C32.9031 8.68967 32.9617 8.99767 32.9617 9.335C32.9617 9.60267 32.9214 9.85567 32.8407 10.094C32.7637 10.3323 32.6501 10.5487 32.4997 10.743C32.3531 10.9373 32.1697 11.1078 31.9497 11.2545C31.7334 11.4012 31.4859 11.5167 31.2072 11.601C31.3026 11.656 31.3906 11.722 31.4712 11.799C31.5519 11.8723 31.6252 11.9603 31.6912 12.063L33.6822 15ZM40.4664 12.0025V9.401C40.4664 9.15533 40.4829 8.884 40.5159 8.587L38.0464 12.0025H40.4664ZM42.6499 12.0025V12.789C42.6499 12.8623 42.6261 12.9265 42.5784 12.9815C42.5307 13.0328 42.4629 13.0585 42.3749 13.0585H41.6489V15H40.4664V13.0585H37.1114C37.0197 13.0585 36.9391 13.031 36.8694 12.976C36.7997 12.9173 36.7557 12.8458 36.7374 12.7615L36.5944 12.074L40.3619 7.0415H41.6489V12.0025H42.6499Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13844_33817",
    x1: 37.8287,
    y1: -17.9838,
    x2: 5.49338,
    y2: 33.8002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00175607,
    stopColor: "#F5A833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303767,
    stopColor: "#FFB444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521046,
    stopColor: "#FFBE5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.740938,
    stopColor: "#FFBA51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AA35"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidTier4Icon);
export default __webpack_public_path__ + "static/media/bfid-tier4-icon.4fe091e3d041b7989051a07afa8bc2d5.svg";
export { ForwardRef as ReactComponent };